
import { useEffect } from "react";
import { Mail, Phone, MapPin } from "lucide-react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { useNavigate } from "react-router-dom";

const Contact = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Update SEO meta tags for contact page
    document.title = "Contact | VakantieUitzoeken.com - Hulp bij het vinden van jouw vakantie";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Heb je hulp nodig bij het vinden van de perfecte vakantie? Neem contact op met VakantieUitzoeken.com voor persoonlijk advies en ondersteuning.');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'contact, hulp, vakantie advies, klantenservice, reisadvies, vakantie hulp');
    }
  }, []);

  // Header navigation handlers
  const handleShowAllVacations = () => navigate('/alle-vakanties');
  const handleShowDeals = () => navigate('/deals');
  const handleShowLuxury = () => navigate('/luxe');
  const handleShowRondreizen = () => navigate('/rondreizen');
  const handleShowThema = () => navigate('/thema');
  const handleShowFavoritesComparison = () => navigate('/favorieten-vergelijken');
  const handleGoHome = () => navigate('/');

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-yellow-50 flex flex-col">
      <Header 
        onShowAllVacations={handleShowAllVacations}
        onShowDeals={handleShowDeals}
        onShowLuxury={handleShowLuxury}
        onShowRondreizen={handleShowRondreizen}
        onShowThema={handleShowThema}
        onShowFavoritesComparison={handleShowFavoritesComparison}
        onGoHome={handleGoHome}
        currentView="contact"
      />
      
      <main className="flex-1">
        <div className="container mx-auto px-4 py-8">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-8">
              <h1 className="text-3xl md:text-4xl font-bold text-orange-600 mb-4">
                Contact
              </h1>
              <div className="text-lg text-gray-600 space-y-2">
                <p>
                  Zoek jij een leuke vakantie voor tieners, maar kom je er niet uit? Laat het ons weten! 
                  Wij helpen jou graag bij het vinden van een leuke vakantie! Ook horen wij het graag als je tips 
                  of opmerkingen hebt over onze website.
                </p>
                <p>
                  Voor persreizen en reviews, kunt u ook contact opnemen via onderstaand mailadres.
                </p>
                <p>
                  Stuur gerust een mailtje naar: administratie@y-catcher.nl
                </p>
              </div>
            </div>

            <div className="max-w-md mx-auto">
              <h2 className="text-2xl font-semibold text-gray-800 mb-6 text-center">
                Contactgegevens
              </h2>
              
              <div className="space-y-6">
                <div className="flex items-center gap-3">
                  <Mail className="h-5 w-5 text-orange-600" />
                  <div>
                    <p className="font-medium">E-mail</p>
                    <p className="text-gray-600">administratie@y-catcher.nl</p>
                  </div>
                </div>
                
                <div className="flex items-center gap-3">
                  <Phone className="h-5 w-5 text-orange-600" />
                  <div>
                    <p className="font-medium">Telefoon</p>
                    <p className="text-gray-600">+31 75 6401793</p>
                  </div>
                </div>
                
                <div className="flex items-center gap-3">
                  <MapPin className="h-5 w-5 text-orange-600" />
                  <div>
                    <p className="font-medium">Adres</p>
                    <p className="text-gray-600">
                      VakantieUitzoeken.com<br />
                      Laboratoriumweg 6A<br />
                      1525 RA Westknollendam
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default Contact;
